$(document).on('click', '#popup_reward .btn-copy', function () {
  navigator.clipboard.writeText($('#popup_reward .reward-code').text());
  $(this).text('Đã copy');
});
